/**
 * A memo chart as words (DOP-655): what a diff, a search and the draft the
 * chat reads get instead of the picture. The chart's shape is the chat's
 * own: `data.labels` with `data.series`, or `data.segments` for a pie.
 */

import type { DealScreeningChart } from "../../types/dealScreening";

interface ChartData {
	labels?: unknown[];
	series?: { name?: unknown; values?: unknown[] }[];
	segments?: { name?: unknown; value?: unknown }[];
}

/** A chart's values as a table: one row per label, one column per series. */
export function chartValues(chart: DealScreeningChart): { columns: string[]; rows: string[][] } {
	const data = chart.data as ChartData;
	if (Array.isArray(data.segments)) {
		return {
			columns: ["Segment", "Value"],
			rows: data.segments.map((segment) => [String(segment.name ?? ""), String(segment.value ?? "")]),
		};
	}
	const series = data.series ?? [];
	return {
		columns: ["", ...series.map((entry, i) => String(entry.name ?? `Series ${i + 1}`))],
		rows: (data.labels ?? []).map((label, i) => [
			String(label ?? ""),
			...series.map((entry) => (entry.values?.[i] == null ? "" : String(entry.values[i]))),
		]),
	};
}

/** A chart as one line: its title, then each label with its values. */
export function chartText(chart: DealScreeningChart): string {
	const { rows } = chartValues(chart);
	return [chart.title ?? "", ...rows.map((row) => row.filter(Boolean).join(" "))]
		.join(" ")
		.replace(/\s+/g, " ")
		.trim();
}
